import { render, staticRenderFns } from "./UserInfoBanner.vue?vue&type=template&id=6adb405b&scoped=true"
import script from "./UserInfoBanner.vue?vue&type=script&lang=js"
export * from "./UserInfoBanner.vue?vue&type=script&lang=js"
import style0 from "./UserInfoBanner.vue?vue&type=style&index=0&id=6adb405b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb405b",
  null
  
)

export default component.exports